import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgZorroModule } from './ng-zorro.module';
import { MaterialModule } from './material.module';
import { ImageCropperModule } from 'ngx-image-cropper';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FileSaverModule } from 'ngx-filesaver';
import { SurveyModule } from 'survey-angular-ui';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { FullCalendarModule } from '@fullcalendar/angular';
import { KeycloakAngularModule } from 'keycloak-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { StoreModule } from '@ngrx/store';
import { menuReducer } from '../reducers/menu.reducer';
import { provideTranslateService, TranslateModule } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '../app-routing.module';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { NZ_ICONS } from 'ng-zorro-antd/icon';

import * as AllIcons from '@ant-design/icons-angular/icons';
import { IconDefinition } from '@ant-design/icons-angular';

import { el_GR, en_GB, NZ_I18N } from 'ng-zorro-antd/i18n';
import { LocaleService } from '../services/locale.service';
import { TerminologySearchDirective } from '../directives/terminology-search.directive';

export function provideNzI18n(localeService: LocaleService) {
  const currentLocale = localeService.getCurrentLocale();
  return currentLocale === 'el' ? el_GR : en_GB;
}

const antDesignIcons = AllIcons as { [key: string]: IconDefinition };
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(
  (key) => antDesignIcons[key]
);

@NgModule({
  imports: [
    TranslateModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    KeycloakAngularModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    StoreModule.forRoot({ menu: menuReducer }),
    CommonModule,
    RouterModule,
    NgZorroModule,
    MaterialModule,
    ImageCropperModule,
    PdfViewerModule,
    FileSaverModule,
    SurveyModule,
    NgxIntlTelInputModule,
    FullCalendarModule,
    TerminologySearchDirective,
  ],
  exports: [
    TranslateModule,
    BrowserModule,
    BrowserAnimationsModule,
    KeycloakAngularModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    CommonModule,
    RouterModule,
    NgZorroModule,
    MaterialModule,
    ImageCropperModule,
    PdfViewerModule,
    FileSaverModule,
    SurveyModule,
    NgxIntlTelInputModule,
    FullCalendarModule,
    TerminologySearchDirective,
  ],
  providers: [
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
    }),
    { provide: NZ_ICONS, useValue: icons },
    {
      provide: NZ_I18N,
      useFactory: provideNzI18n,
      deps: [LocaleService],
    },
  ],
})
export class SharedModule {}
